import React, {useState} from 'react'
import { Box} from '@mui/material'
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
import CustomerButton from '../../MasterFile/CustomerTable/CustomerButton';

const firstRow = {
    id: 1,
    Regno: "",
    Make: "",
    Model: "",
    MOTDue: "",
    Last_Vist: "",
    
    
}
const dataGridStyle = {
  root: {
    "& .MuiDataGrid-root": {
      borderRadius: '10px',
      backgroundColor: 'white',
      fontSize: '15px',
    },
    "& .MuiDataGrid-columnHeaders": {
      color: '#005A9C',
      fontSize: '16px',
    }
  },
};
// const boxStyle = {
//     root: {
//       backgroundColor: 'white', 
//       borderRadius: '5px',
//       padding: 1
//     },
//   };


function CustomColumnMenu(props) {
    return (
      
      <GridColumnMenu
        {...props}
        slots={{
       // Hide `columnMenuColumnsItem`
        columnMenuColumnsItem: null,
        columnMenuSortItem: null,
        }}
      />
      
  );
  }
       



function VehiceOwned() {
  const [rows, setRows] = useState([firstRow])
    const columns = [
    { field: 'id', headerName: ' NO', editable: false, sortable: false},
    { field: 'Regno', headerName: 'Reg No', editable: false, flex: 1,sortable: false},
    { field: 'Make', headerName: 'Make', editable: false, sortable: false, flex: 1, minWidth: 100  },
    { field: 'Model', headerName: 'Model', editable: false, sortable: false, flex: 1, minWidth: 100  },
    { field: 'MOTDue', headerName: 'MOT Due', editable: false, flex: 1,sortable: false},
    { field: 'Last_Vist', headerName: 'Last Vist', editable: false,flex: 1, sortable: false},
    { field: 'action', headerName: 'Actions', sortable: false, flex: 1, minWidth: 110,
    renderCell: (params) => {
        return (
        <CustomerButton rows={rows} params={params} setRows={setRows} firstRow={firstRow} field='Regno'/>
        ); }
    }
    ];
    
    // const rows = [
    // { id: '1', Regno: '', Make: '', Model: '', MOTDue:'', Last_Vist:''},
    
    // ]; 

    return (
      <form>
        <Box sx={dataGridStyle.root} mt={1}>
          <DataGrid
            columnHeaderHeight={30}
            rowHeight={30}
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
            pageSizeOptions={[10]}
            slots={{ columnMenu: CustomColumnMenu }}
            disableRowSelectionOnClick
          />
        </Box>
      </form>
    );
}

export default VehiceOwned